/**
 * NiceAdmin-style feedback overrides: buttons, baseline.
 */
export const feedbackCustomizations = {
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        textTransform: 'none',
        fontWeight: 600,
      },
    },
  },
  MuiCssBaseline: {
    styleOverrides: {
      body: { backgroundColor: '#FFFFFF' },
      a: { color: 'inherit !important', textDecoration: 'none !important' },
      'a:visited': { color: 'inherit !important' },
    },
  },
};
